import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { PERSON_STATES, PROGRESS_STATES } from 'constants/enums'
import styles from './status.styl'

export default class Status extends Component {
  static propTypes = {
    state: PropTypes.any,
    check: PropTypes.bool,
    noWaiting: PropTypes.bool,
    toRight: PropTypes.bool,
    inline: PropTypes.bool
  }

  static defaultProps = {
    noWaiting: false
  }

  render() {
    const { state, check, inline, toRight, noWaiting } = this.props
    let text = ''
    let defaultClass = ''
    let statusClass = ''
    const inlineClass = inline ? styles.inline : ''
    const toRightClass = toRight ? styles.toRight : ''

    if (state === undefined || state === null) {
      return null
    }

    if (!check) {
      switch (state.value) {
        case PERSON_STATES.active.id:
          statusClass = styles.positive
          break
        case PERSON_STATES.activating.id:
        case PERSON_STATES.inactive.id:
          statusClass = styles.negative
          break
        case PROGRESS_STATES.approvementState.id:
          statusClass = styles.positive
          break
        default:
          statusClass = ''
      }

      text = state.translationText
    }

    if (check) {
      if (state) {
        text = <span className={`ico ${styles.ico} ico--checked`} />
      } else if (!state) {
        text = <span className="ico ico--waiting" />

        if (noWaiting) {
          text = <span className={`ico ${styles.ico} ico--clear`} />
        }
      }
      defaultClass = styles.defaultCheck
      statusClass = state ? styles.positive : styles.negative
    }

    const className = [
      styles.status,
      defaultClass,
      statusClass,
      inlineClass,
      toRightClass
    ].join(' ')

    return <span className={className}>{text}</span>
  }
}
